import store from '@/store'

export default [
  {
    path: '/vehicle-operations',
    name: 'vehicle-operation',
    meta: { requiresAuth: true },
    component: () => import('@/pages/vehicle-operation/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('vehicleOperation/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/vehicle-operations/:id',
    name: 'vehicle-operation-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/vehicle-operation/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('vehicleOperation/dataBeforeCreate')
      await store.dispatch('vehicleOperation/find', to.params.id)
      next()
    }
  }
]
